import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FilterModel } from 'ag-grid-enterprise';
import { merge } from 'lodash';
import { DateTime } from 'luxon';
import { Note } from 'src/app/classes/models';
import { GenericObject } from 'src/app/interfaces/generic-object';
import { GridActionColumnActions } from 'src/app/interfaces/grid-action-column-actions';
import { GridActionColumnMap } from 'src/app/interfaces/grid-action-column-map';
import { NoteDisplayModalComponent } from 'src/app/modals/note-display-modal/note-display-modal.component';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-change-log',
  templateUrl: './change-log.component.html',
  styleUrl: './change-log.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ChangeLogComponent implements OnInit {
  constructor(
    private ToastService: ToastService,
    private ModalService: NgbModal
  ) {}

  @Input() VendorId?: number;
  @Input() CompanyId?: number;
  @Input() SuppliedQueryObject?: GenericObject;

  SuppliedGridQueryData!: GenericObject;

  // Display these actions in the action column.
  ColumnIdToColumnActions: GridActionColumnMap = {
    ['$actionColumn']: ['view']
  };

  FilterModel: FilterModel = {
    createdAt: {
      filterType: 'date',
      type: 'greaterThan',
      dateFrom: DateTime.fromJSDate(new Date())
        .minus({ months: 1 })
        .toFormat('yyyy-MM-dd HH:mm:ss'),
      dateTo: null
    }
  };

  action({
    action,
    rowData
  }: {
    action: GridActionColumnActions;
    rowData: Note;
  }) {
    if (action === 'view') {
      const { id: NoteId } = rowData;

      // Open note modal.
      const { componentInstance } = this.ModalService.open(
        NoteDisplayModalComponent,
        { backdrop: 'static', size: 'lg' }
      );
      Object.assign(componentInstance, { NoteId });
    }
  }

  ngOnInit(): void {
    this.SuppliedGridQueryData = {
      isChangeLog: true,
      isSensitive: true
    };

    if (this.SuppliedQueryObject) {
      merge(this.SuppliedGridQueryData, this.SuppliedQueryObject);
    }
  }
}
